import { useEffect, useRef, type PointerEvent } from "react";
import type { MoreTool } from "lib/moreToolsData";
import { MoreToolIconSvg } from "./MoreToolIconSvg";

export default function MoreToolCard({
  tool,
  index,
}: {
  tool: MoreTool;
  index: number;
}) {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in");
        });
      },
      { threshold: 0.15 }
    );
    el.style.transitionDelay = `${(index % 7) * 40}ms`;
    io.observe(el);
    return () => io.disconnect();
  }, [index]);

  const onMove = (e: PointerEvent<HTMLElement>) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  return (
    <article
      ref={ref}
      onPointerMove={onMove}
      className="mt-card mt-card--tg"
    >
      <div className="mt-icn">
        <MoreToolIconSvg
          icon={tool.icon}
          className="mt-ic"
          label={`${tool.name} icon`}
        />
      </div>
      <span className="mt-cat">{tool.cat}</span>
      <h3>{tool.name}</h3>
      <p className="mt-desc">{tool.desc}</p>
      <ul className="mt-feats">
        {tool.feats.map((f) => (
          <li key={f}>{f}</li>
        ))}
      </ul>
      <div className="mt-actions">
        <a
          className="mt-btn mt-btn-primary"
          href={tool.installUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Install Free
        </a>
        <a
          className="mt-btn mt-btn-ghost"
          href={tool.tutorialUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Watch Tutorial
        </a>
      </div>
    </article>
  );
}
